module.exports = __webpack_public_path__ + "img/L5.351db281.png";